import React, { useEffect, useState } from 'react';
import {
  Avatar, Button, FormControl, InputLabel, MenuItem, Select, Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { useSelector } from 'react-redux';
import { checkPermission } from 'src/utils/permission';
import { SelectVehicleMake, fetchVehicleVariant } from 'src/features/staticDataSlice';
import VehicleModelPopUp from 'src/pages/VehichleModel/VehicleModelModel';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function VehicleModel({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  apiUrl,
  handleChange,
  vehicleModelData = [],
  setVehicleVariantData
}) {

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [riskFactorCreatePermission, setRiskFactorCreatePermission] = useState(false);
  const [vehicleMakeId, setVehiclemakeId] = useState(null);
  const [vehicleModelDataList, setVehicleModelDataList] = useState([]);
  const [newValue, setNewValue] = useState<string>('');
      useEffect(() => {
        if (newValue !== undefined && newValue !== '') {
          handleChange('vehicleModel', index, newValue);      
          saveRow(index);
        } else if (newValue === undefined) {
           handleChange('vehicleModel', index, '');  
        }
      }, [newValue]);

  useEffect(() => {
    if(vehicleModelData[index])
    setVehicleModelDataList(vehicleModelData[index] || []);
  }, [vehicleModelData, index]);

  useEffect(() => {
    checkPermission(apiUrl.permission_key, 'Create').then(setRiskFactorCreatePermission);
  }, []);

  const vehicleMake = useSelector(SelectVehicleMake);
  useEffect(() => {
    if (vehicleMake) {
      let vehicleMakeInfo = vehicleMake.find(make => make.name == tableListDatas[index]['vehicleMake']);
      setVehiclemakeId(vehicleMakeInfo?.id || 0)
    }
    if (vehicleModelDataList) {
      fetchVehicleVariantDataByModel();
    }

  }, [vehicleMake, tableListDatas, index, apiUrl.formKey, vehicleModelDataList])

  const fetchVehicleVariantDataByModel = (modelName = null) => {
    const selectedModelName = modelName ? modelName : tableListDatas[index][apiUrl.formKey];
    const modelInfo = vehicleModelDataList.find(m => m.name === selectedModelName);
    if (modelInfo?.id) {
      fetchVehicleVariant(modelInfo.id, 'vehichle/listVehicleVariant')
        .then(data => {
          setVehicleVariantData(prev => {
              // if nothing has changed, return previous state
            if (JSON.stringify(prev[index]) === JSON.stringify(data)) {
              return prev;
            }
            const updated = [...prev];
            updated[index] = data;
            return updated;
          });
        });
    }
  };

  return (
    <>
   
      <FormControl fullWidth size="small">
        <StyledInputLabel id={`select-label-${apiUrl.formKey}`}>
          {label}
        </StyledInputLabel>
        <Select
          labelId={`select-label-${apiUrl.formKey}`}
          id={`select-${apiUrl.formKey}`}
          value={tableListDatas[index]?.[apiUrl.formKey] || ''}
          onChange={(e) => {
            const value = e.target.value;
            handleChange(apiUrl.formKey, index, value);
            // handleChange('vehicleVariant', index, '');
            saveRow(index);
            fetchVehicleVariantDataByModel(value);
          }}
          style={{ width: '100%', minWidth: 180 }}
        >
          {vehicleModelDataList.map(model => (
            <MenuItem key={model.name} value={model.name}>
              {model.name}
            </MenuItem>
          ))}
          <Tooltip
            title={
              riskFactorCreatePermission ? '' : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar src={lock} sx={{ width: 24, height: 24, mr: 1 }} />
                  You don't have permission to add Vehicle Model
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => riskFactorCreatePermission && setOpenCreateModal(true)}
              sx={{ color: riskFactorCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
      </FormControl>

      {openCreateModal && (
        <VehicleModelPopUp
          handleClose={() => setOpenCreateModal(false)}
          riskFactorname=""
          apiUrl={apiUrl}
          productId={productId}
          setNewValue={setNewValue}
          makeId={vehicleMakeId}
        />
      )}
    </>
  );
}

export default VehicleModel;
